<template>
    <nav class="navbar">
        <div class="d-flex align-items-center navbar-item justify-content-between">
            <div>
                <router-link to="/"><img src="@/assets/images/logo.svg"></router-link>
            </div>
            <div>
                <h1 class="title">АИС РМЛ РАС</h1>
                <span class="location">Нижний Новгород</span>
            </div>
        </div>

        <div class="menu navbar-item m-2">
            <router-link class="header-link  text-decoration-none" to="/m-chat-r" v-if="!$store.state.auth?.oidc?.user"><button-component class="btn-sm quest-btn">Анкетирование</button-component></router-link>
<!--            <router-link to="/">Главная</router-link>-->
<!--            <router-link to="/protected">Защищенная страница</router-link>-->
<!--            <router-link class="header-link" to="/m-chat-r">Анкетирование</router-link>-->

        </div>
        <!-- Right navbar links -->
        <div class="d-flex navbar-item align-items-center">
            <div class="mail ml-auto" v-if="$store.state.auth?.oidc?.user">
                <icon-component v-if="isSystemChatAvailable" class="mr-1" name="mail" @click="openMessenger"/>
                <span v-if="isSystemChatAvailable" :class="{'text-bold':unreadMessageCount > 0}"
                      @click="openMessenger">{{unreadMessageCount}}</span>
            </div>

            <div class="user" v-if="$store.state.auth?.oidc?.user">
                <span class="name">{{ $store.state.auth.oidc.user.profile.family_name }}</span>
                <span v-if="$store.state.auth.oidc.isExpired"> expired</span>
            </div>

            <div class="logout" v-if="$store.state.auth?.oidc?.user">
                <router-link to="/logout">
                    <icon-component class="logout-icon" name="logout"/>
                </router-link>
            </div>
            <div class="login ml-auto" v-else>
                <router-link class="text-decoration-none" to="/login"><button-component class="btn-sm">Личный кабинет</button-component></router-link>
            </div>
        </div>
    </nav>
    <section class="modals">
        <modal-component v-if="modals.messenger.show" 
            title="Мессенджер" 
            class="modal-content--card"
            size-class="modal-xl modal-fullscreen-lg-less"
            @close="modals.messenger.show = false">
          <MessengerForm :filter="modals.messenger.filter"></MessengerForm>
        </modal-component>
    </section>
</template>

<script>

import IconComponent from "../ui/IconComponent";
import userManager from "@/modules/auth/user-manager";
import ButtonComponent from "./ButtonComponent";
import MessageApi from "@/modules/messenger/api/index";
import ModalComponent from "../ui/ModalComponent";
import MessengerForm from "../../modules/messenger/components/MessengerForm";
import Constants from "@/common/constants";
import security from "../mixins/security";

export default {
  name: "HeaderComponent",
  components: {MessengerForm, ModalComponent, ButtonComponent, IconComponent},
  mixins: [security],
  data() {
    return {
      isSystemChatAvailable: false,
      unreadMessageCount: 0,
      modals: {
        messenger: {
          filter: {
            //dialogType: Constants.SystemDialogType
            dialogType: [Constants.CuratorDialogType, Constants.SystemDialogType],
          },
          show: false
        }
      }
    };
  },
  created() {
    setTimeout(() => {
      this.checkPermission(Constants.ViewSystemMessages)
          .then((response) => {
            this.isSystemChatAvailable = response.data;
            if (this.isSystemChatAvailable) {
              MessageApi.getUnreadMessageCount().then((response) => {
                this.unreadMessageCount = response.data;
              });
            }
          });
    }, 500);
  },
  methods: {
    signinRedirect() {
      const returnUrl = this.$route.query.returnUrl;
      const storageKey = "login_return_url";
      if (returnUrl) {
        sessionStorage.setItem(storageKey, returnUrl);
      } else {
        sessionStorage.removeItem(storageKey);
      }
      userManager.signinRedirect();
    },
    openMessenger(filter) {
      if (filter) {
        Object.assign(this.modals.messenger.filter, filter);
      }
      this.modals.messenger.show = true;
    }
  }
};

</script>

<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.navbar {
    display: flex;
    gap: 16px;
    align-items: center;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    border: none;
    padding: 10px 20px;
    //.navbar-item{
    //    max-width: 232px;
    //    width: 100%;
    //    text-align: right;
    //}
    .title {
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 126%;
        /* or 30px */

        letter-spacing: 0.03em;
        text-transform: uppercase;
        margin: 0;
        justify-content: center;
    }

    .location {
        color: $gray-dark;
        cursor: pointer;
    }

    .mail {
        display: flex;
        gap: 8px;
        cursor: pointer;
    }

    .user {
        margin-right: 40px;
        font-weight: 500;
        //cursor: pointer;
    }

    .mail, .user, .logout, .login {
        color: $black;

        &:hover {
            color: $blue;
        }
    }
    .mail {
        span {
            margin-right: 20px;
        }
    }
}
.text-bold {
    font-weight: bold;
}
.quest-btn{
  margin-right: 90px !important;
}
</style>